import { render, staticRenderFns } from "./TerminateGroupDialog.vue?vue&type=template&id=53e2b2fc&"
import script from "./TerminateGroupDialog.vue?vue&type=script&lang=ts&"
export * from "./TerminateGroupDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports